// Centralised permission codes — keep in sync with core_permissions table.
export const PERMS = {
  CAN_SEND_ADMIT_CARD_LINK: 'can-send-admit-card-download-link',
  CAN_SUBMIT_ACCOUNTS_REPORT: 'can-submit-accounts-reconciliation-report',
  CAN_SUBMIT_LIBRARY_REPORT: 'can-submit-library-reconciliation-report',
  CAN_PROMOTE_STUDENTS: 'can-promote-students',
  CAN_CANCEL_ADMISSION: 'can-cancel-admission',
};

export const REPORT_TYPE_PERMS = {
  accounts: PERMS.CAN_SUBMIT_ACCOUNTS_REPORT,
  library: PERMS.CAN_SUBMIT_LIBRARY_REPORT,
};

export const REPORT_TYPE_LABELS = {
  accounts: 'Accounts',
  library: 'Library',
};
